import { Record } from 'immutable';

const LinkReservationRequestRecord = Record({
  eventReservationIdList: null,
  payViaGp: true,
  eventPartyId: null
});

export class LinkReservationRequest extends LinkReservationRequestRecord {
  eventReservationIdList: number[];
  payViaGp: boolean;
  eventPartyId: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/link-reservation-request.ts